import { render } from "./DocumentContentModalComponent.vue?vue&type=template&id=5f918d88&scoped=true"
import script from "./DocumentContentModalComponent.vue?vue&type=script&lang=js"
export * from "./DocumentContentModalComponent.vue?vue&type=script&lang=js"

import "./DocumentContentModalComponent.vue?vue&type=style&index=0&id=5f918d88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f918d88"]])

export default __exports__